import React, { Component } from "react"
import { Glyphicon, Grid, Row, Col, Badge, Alert } from "react-bootstrap"
import "./UpgradePanel.css"
import firebase from "firebase"

export default class UpgradePanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isPurchasing: false,
			errorMessage: null,
		}
	}

	render() {
		const { errorMessage } = this.state
		return (
			<div>
				<Grid fluid>
					<Row>
						<Col md={9}>
							<h1 className="up-heading">Ready to upgrade?</h1>
							<ul className="up-features-list">
								<li>
									<Glyphicon glyph="ok" /> Track <b>unlimited trades</b> on all
									supported exchanges
								</li>
								<li>
									<Glyphicon glyph="ok" /> <b>Concierge chat support</b> with 1
									business day response time or less
								</li>
							</ul>
						</Col>
						<Col md={3} xs={6}>
							<h2 className="up-heading2">1 Year Pro</h2>
							<div className="up-price-box">
								<span className="up-regular-price">$39.95</span>{" "}
								<span className="up-discount-price">$29.95</span>{" "}
								<Badge>-25%</Badge>
								<p className="up-discount-message">
									Purchase before your trial ends and save 25%!
								</p>
							</div>
							{this.buyButton("Pro", "pro", 29.95)}
							{errorMessage !== null ? (
								<Alert bsSize="danger">{errorMessage}</Alert>
							) : null}
						</Col>
					</Row>
				</Grid>
			</div>
		)
	}

	buyButton(name, plan, price) {
		const user = firebase.auth().currentUser
		const uid = user.uid

		if (user === null) {
			throw new Error("No user!")
		}

		return (
			<form action="https://www.coinpayments.net/index.php" method="post">
				<input type="hidden" name="cmd" value="_pay_simple" />
				<input type="hidden" name="reset" value="1" />
				<input
					type="hidden"
					name="merchant"
					value={process.env.REACT_APP_COINPAYMENTS_MERCHANT_ID}
				/>
				<input type="hidden" name="currency" value="USD" />
				<input type="hidden" name="amountf" value={price} />
				<input
					type="hidden"
					name="item_name"
					value={`Crypto Portfolio Tracker - ${name} 1 Year`}
				/>
				<input type="hidden" name="item_number" value={plan} />
				<input type="hidden" name="first_name" value={user.displayName} />
				<input type="hidden" name="email" value={user.email} />
				<input type="hidden" name="custom" value={uid} />
				<input
					type="hidden"
					name="ipn_url"
					value={process.env.REACT_APP_COINPAYMENTS_IPN_URL || ""}
				/>
				<input type="hidden" name="success_url" value={window.location.href} />
				<input type="hidden" name="cancel_url" value={window.location.href} />
				<input
					type="image"
					src="https://www.coinpayments.net/images/pub/buynow-wide-yellow.png"
					alt="Buy Now with CoinPayments.net"
					className="up-buy-button"
				/>
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/UpgradePanel.js